import React from 'react';
import { wrap, buttonArea, contentsArea } from './style';

interface Props {
  alertTitle?: string;
  onClose: () => void;
}

function Alert({
  alertTitle,
  children,
  onClose,
}: React.PropsWithChildren<Props>) {
  return (
    <div css={wrap}>
      <div css={contentsArea}>{children}</div>
      <div css={buttonArea}>
        <button type="button" onClick={onClose}>
          {alertTitle || '확인'}
        </button>
      </div>
    </div>
  );
}

export default Alert;
